import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import "../styles/Asummery.css";
import { useNavigate } from "react-router-dom";


function SecuritySum() {
  const [pivotData, setPivotData] = useState([]);
  const [emails, setEmails] = useState([]);
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");  

  useEffect(() => {
  async function fetchData() {
    
    // 🔹 fetch users with roles
    const usersSnap = await getDocs(collection(db, "users"));
    const usersData = usersSnap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // 🔹 fetch reviews (only Centauria Lake)
    let reviewList = (await getDocs(collection(db, "reviews")))
      .docs.map((doc) => ({ id: doc.id, ...doc.data() }))
      .filter((r) => r.hotelName === "Sarathchandra Textile");

    // 🔹 filter by selected date range
    if (startDate) {
      const start = new Date(startDate);
      reviewList = reviewList.filter((r) => r.createdAt?.toDate() >= start);
    }
    if (endDate) {
      const end = new Date(endDate);
      end.setHours(23, 59, 59); // include full day
      reviewList = reviewList.filter((r) => r.createdAt?.toDate() <= end);
    }

    // 🔹 collect security users who have reviews in Centauria Lake
    const reviewUserEmails = [...new Set(reviewList.map((r) => r.userEmail))];

    const allowedUsers = usersData.filter(
      (u) => u.role === "security" && reviewUserEmails.includes(u.email)
    );

    const allowedEmails = allowedUsers.map((u) => u.email);


    
    // 🔹 collect unique points (only starting with "SP", case-insensitive)
      const uniquePoints = [
        ...new Set(
          reviewList
            .map((r) => r.qrData || "Unknown Point")
            .filter((point) => point.toLowerCase().startsWith("s p"))
        ),
      ];


    // 🔹 build pivot table with counts and last review date
    const table = uniquePoints.map((point) => {
      const row = { point };
      allowedEmails.forEach((email) => {
        const userReviews = reviewList.filter(
          (r) =>
            (r.userEmail || "Unknown") === email &&
            (r.qrData || "Unknown Point") === point
        );
        const count = userReviews.length;

        // 🔹 get last review date if exists
        let lastDate = "-";
        if (userReviews.length > 0) {
          const latestReview = userReviews.reduce((latest, current) => {
            const latestTime = latest.createdAt?.toDate?.()?.getTime?.() || 0;
            const currentTime = current.createdAt?.toDate?.()?.getTime?.() || 0;
            return currentTime > latestTime ? current : latest;
          });
          // ✅ Format directly as "DD Mon" (no year)
                lastDate = latestReview.createdAt?.toDate
                  ? latestReview.createdAt.toDate().toLocaleDateString("en-US", {
                      day: "2-digit",
                      month: "short", // e.g. "30 Aug"
                    })
                  : "-";
        }

       row[email] = count > 0 ? (
          <>
            {count}
            <br />
            ({lastDate})
          </>
        ) : "-";

      });
      return row;
    });

    setEmails(allowedEmails);
    setPivotData(table);
  }

   fetchData();
}, [startDate, endDate]); // ✅ auto-run when dates change


  return (

    <div className="summary-container">

    <button onClick={() => navigate("/txtsadmin")} className="history-btn">
       Home
      </button>

      <h2>📊 User Points Summary</h2>

       <div className="date-filter">
        <label>
          Start Date: 
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </label>
        <label>
          End Date: 
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </label>
      </div>

      <div className="table">
        <table className="summary-table">
          <thead>
            <tr>
             <th>Points</th>
            {emails.map((email, idx) => (
            <th key={idx}>{email.split("@")[0]}</th>
            ))}
            </tr>
          </thead>
          <tbody>
            {pivotData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.point}</td>
                {emails.map((email, idx) => (
                  <td key={idx}>{row[email]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SecuritySum;
